export const composition = [
  { key: "iptuArea", "label": "Área no IPTU" },
  { key: "landSizeUseful", "label": "Área construída" },
  { key: "iptuValue", "label": "Valor do IPTU (R$ anual)", isNew: true, },
  { key: "condominiumPrice", "label": "Valor do condomínio" },
  { key: "condominiumInfrastructure", "label": "Infraestrutura do condomínio", isNew: true, },
  { key: "floor", "label": "Andar", isNew: true, },
  { key: "position", "label": "Posição do imóvel" },
  { key: "penthouseType", "label": "Tipo de cobertura", isNew: true, },
  { key: "hasElevatorToPenthouse", "label": "Elevador chega até a cobertura?", isNew: true, },
  { key: "hasElevator", "label": "Tem elevador", isNew: true },
  { key: "useType", "label": "Comercial", isNew: true },
  { key: "bedrooms", "label": "Total de quartos" },
  { key: "rooms", "label": "Total de cômodos", isNew: true, },
  { key: "bathrooms", "label": "Total de banheiros (inclui suítes)" },
  { key: "suites", "label": "Total de suítes" },
  { key: "dependencies", "label": "Dependências", isNew: true, },
  { key: "leisureArea", "label": "Espaço de lazer", isNew: true, },
  { key: "parkingSpots", "label": "Total de vagas" },
  { key: "scripture", "label": "Vagas na escritura" },
  { key: "landArea", "label": "Área do terreno", isNew: true, },
  { key: "numberFloors", "label": "Nº pavimentos", isNew: true, },
  { key: "floorArea", "label": "Área dos pavimentos", isNew: true, },
  { key: "hasPreservationAreaEnvironmental", "label": "Área de preservação ambiental?", isNew: true, },
  { key: "facingTheStreet", "label": "Frente para a rua", isNew: true, },
  { key: "centerOfTheTerrain", "label": "Localizado no centro do terreno?", isNew: true, },
  { key: "hasPenthouse", "label": "Possui cobertura?", isNew: true, },
  { key: "subsoil", "label": "Possui subsolo?", isNew: true, },
  { key: "unitsPerFloor", "label": "Nº unidades por andar", isNew: true, },
  { key: "unitArea", "label": "Área das unidades", isNew: true, },
  { key: "occupancyType", "label": "Tipo de ocupação", isNew: true, },
  { key: "frontalFootage", "label": "Metragem de frente", isNew: true, },
  { key: "deforestationRequired", "label": "Necessita desmatamento?", isNew: true, },
  { key: "constructArea", "label": "Área construída" },
];

export const compositionOptions = [
  {
    sectionKey: "basicInfo",
    "section": "Informações básicas",
    "fields": [
      {
        "key": "landSizeUseful",
        "label": "Área construída (m²)",
        "type": "number"
      },
      {
        "key": "iptuArea",
        "label": "Área no IPTU (m²)",
        "type": "number",
        "required": true
      },
      {
        "key": "condominiumPrice",
        "label": "Valor do condomínio (R$)",
        "type": "number"
      },
      {
        "key": "iptuValue",
        "label": "Valor do IPTU (R$ anual)",
        "type": "number",
        "required": true
      },
      {
        "key": "condominiumInfrastructure",
        "label": "Infraestrutura do condomínio",
        "type": "text",
        "options": [
          { "label": "Não tem", "value": "nao_tem" },
          { "label": "Parcial", "value": "parcial" },
          { "label": "Total", "value": "total" }
        ]
      },
      {
        key: "useType",
        label: "Uso",
        "type": "text",
        "options": [
          { "label": "Residencial", "value": "Residencial", default: true },
          { "label": "Comercial", "value": "Comercial" },
          { "label": "Misto", "value": "Misto" }
        ],
        "required": true
      },
      {
        key: "hasElevator",
        label: "Tem elevador",
        type: "bool",
      },
    ]
  },
  {
    sectionKey: "construction",
    "section": "Terreno e construção",
    "fields": [
      {
        "key": "landArea",
        "label": "Área do terreno (m²)",
        "type": "number",
        "required": true
      },
      {
        "key": "hasPreservationAreaEnvironmental",
        "label": "Tem preservação",
        "type": "bool"
      },
      {
        "key": "numberFloors",
        "label": "Nº pavimentos",
        "type": "number"
      },
      {
        "key": "floorArea",
        "label": "Área dos pavimentos (m²)",
        "type": "number"
      },
      {
        "key": "facingTheStreet",
        "label": "Frente de rua",
        "type": "bool"
      },
      {
        "key": "centerOfTheTerrain",
        "label": "Centro de terreno",
        "type": "bool"
      },
      {
        "key": "hasPenthouse",
        "label": "Cobertura",
        "type": "bool"
      },
      {
        "key": "subsoil",
        "label": "Subsolo",
        "type": "bool"
      }
    ]
  },
  {
    sectionKey: "EdificationLocation",
    "section": "Localização na edificação",
    "fields": [
      {
        "key": "floor",
        "label": "Andar",
        "type": "number",
        "required": true
      },
      {
        "key": "position",
        "label": "Posição",
        "type": "text",
        "options": [
          { "label": "Frente", "value": "frente" },
          { "label": "Lateral", "value": "lateral" },
          { "label": "Fundos", "value": "fundos" }
        ],
        "required": true
      },
      {
        "key": "penthouseType",
        "label": "Tipo de cobertura",
        "type": "text",
        "options": [
          { "label": "Linear", "value": "linear" },
          { "label": "Duplex", "value": "duplex" },
          { "label": "Triplex", "value": "triplex" }
        ]
      },
      {
        key: "hasElevatorToPenthouse",
        label: "Elevador chega até a cobertura?",
        type: "bool",
      },
    ]
  },
  {
    sectionKey: "composition",
    "section": "Composição",
    "fields": [
      {
        "key": "bedrooms",
        "label": "Total de quartos",
        "type": "number",
        "required": true
      },
      {
        "key": "bathrooms",
        "label": "Total de banheiros (inclui suítes)",
        "type": "number",
        "required": true
      },
      {
        "key": "suites",
        "label": "Total de suítes",
        "type": "number",
        "required": true
      },
      {
        "key": "hasDependencies",
        "label": "Dependências",
        "type": "bool",
        "required": true
      },
      {
        "key": "leisureArea",
        "label": "Espaço de lazer",
        "type": "bool"
      },
      {
        "key": "numberFloors",
        "label": "Nº pavimentos",
        "type": "number"
      },
      {
        "key": "unitsPerFloor",
        "label": "Nº unidades por andar",
        "type": "number"
      },
      {
        "key": "unitArea",
        "label": "Área das unidades (m²)",
        "type": "number"
      },
      {
        "key": "occupancyType",
        "label": "Ocupação",
        "type": "text",
        "options": [
          { "label": "Vazio", "value": "vazio" },
          { "label": "Ocupado", "value": "ocupado" },
          { "label": "Parcialmente ocupado", "value": "parcial_ocupado" }
        ]
      }
    ]
  },
  {
    sectionKey: "parking",
    "section": "Estacionamento",
    "fields": [
      {
        "key": "parkingSpots",
        "label": "Total de vagas",
        "type": "number",
        "required": true
      },
      {
        "key": "scripture",
        "label": "Vagas na escritura",
        "type": "bool"
      }
    ]
  },
  {
    sectionKey: "featuresPlace",
    "section": "Características do terreno",
    "fields": [
      {
        "key": "frontalFootage",
        "label": "Metragem da frente (m)",
        "type": "number"
      },
      {
        "key": "constructArea",
        "label": "Área construída (m²)",
        "type": "number"
      },
      {
        "key": "deforestationRequired",
        "label": "Necessita desmatamento",
        "type": "bool"
      },
      {
        "key": "leisureArea",
        "label": "Área de lazer",
        "type": "bool"
      }
    ]
  }
];

export const propertyTypeSections = [
  {
    propertyType: 24,
    name: "Apartamento",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "condominiumInfrastructure"
        ]
      },
      {
        name: "Localização na edificação",
        key: "EdificationLocation",
        fields: [
          "floor",
          "position"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 37,
    name: "Flat",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "condominiumInfrastructure"
        ]
      },
      {
        name: "Localização na edificação",
        key: "EdificationLocation",
        fields: [
          "floor",
          "position"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 26,
    name: "Cobertura",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "condominiumInfrastructure"
        ]
      },
      {
        name: "Localização e configuração",
        key: "EdificationLocation",
        fields: [
          "floor",
          "position",
          "penthouseType",
          "hasElevatorToPenthouse",
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies",
          "leisureArea"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "numberFloors",
          // "floorArea",
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      },
    ]
  },
  {
    propertyType: 25,
    name: "Casa de Rua",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "useType",
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "numberFloors",
          // "floorArea",
          "hasPreservationAreaEnvironmental"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies",
          "leisureArea",
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
        ]
      }
    ]
  },
  {
    propertyType: 39,
    name: "Casa Comercial",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "numberFloors",
          // "floorArea",
          "hasPreservationAreaEnvironmental"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "rooms",
          "bathrooms",
          "dependencies",
          "leisureArea"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
        ]
      }
    ]
  },
  {
    propertyType: 29,
    name: "Casa de Condomínio",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "numberFloors",
          // "floorArea",
          "hasPreservationAreaEnvironmental"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies",
          "leisureArea"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 30,
    name: "Casa de Vila",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "numberFloors",
          // "floorArea",
          "hasPreservationAreaEnvironmental"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "bedrooms",
          "bathrooms",
          "suites",
          "dependencies",
          "leisureArea"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 40,
    name: "Conjunto Comercial/Sala",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Localização na edificação",
        key: "EdificationLocation",
        fields: [
          "floor",
          "position"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "rooms",
          "bathrooms"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 44,
    name: "Loja Shopping/Centro Comercial",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "facingTheStreet"
        ]
      },
      {
        name: "Construção",
        key: "construction",
        fields: [
          "numberFloors",
          "floorArea"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "rooms",
          "bathrooms"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 45,
    name: "Loja/Salão",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "facingTheStreet"
        ]
      },
      {
        name: "Construção",
        key: "construction",
        fields: [
          "numberFloors",
          "floorArea"
        ]
      },
      {
        name: "Composição",
        key: "composition",
        fields: [
          "rooms",
          "bathrooms"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 50,
    name: "Prédio",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice",
          "useType",
          "hasElevator",
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "centerOfTheTerrain",
          "hasPreservationAreaEnvironmental",
          "numberFloors",
          "hasPenthouse",
          "subsoil"
        ]
      },
      {
        name: "Unidades",
        key: "composition",
        fields: [
          "unitsPerFloor",
          // "unitArea",
          "occupancyType"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    disabled: true,
    propertyType: 48,
    name: "Prédio Inteiro",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "centerOfTheTerrain",
          "hasPreservationAreaEnvironmental",
          "numberFloors",
          "hasPenthouse",
          "subsoil"
        ]
      },
      {
        name: "Unidades",
        key: "composition",
        fields: [
          "unitsPerFloor",
          // "unitArea",
          "occupancyType"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 41,
    name: "Galpão/Depósito/Armazém",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Terreno e construção",
        key: "construction",
        fields: [
          "landArea",
          "centerOfTheTerrain",
          "hasPreservationAreaEnvironmental",
          "numberFloors",
          // "floorArea",
          "hasPenthouse",
          "subsoil",
          "occupancyType"
        ]
      },
      {
        name: "Estacionamento",
        key: "parking",
        fields: [
          "parkingSpots",
          "scripture"
        ]
      }
    ]
  },
  {
    propertyType: 31,
    name: "Loteamento/Condomínio",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Características do terreno",
        key: "featuresPlace",
        fields: [
          "frontalFootage",
          "deforestationRequired",
          // "constructArea"
        ]
      }
    ]
  },
  {
    propertyType: 32,
    name: "Terreno Padrão",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue",
          "condominiumPrice"
        ]
      },
      {
        name: "Características do terreno",
        key: "featuresPlace",
        fields: [
          "frontalFootage",
          "deforestationRequired",
          // "constructArea"
        ]
      }
    ]
  },
  {
    propertyType: 33,
    name: "Chácara",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue"
        ]
      },
      {
        name: "Características da área",
        key: "featuresPlace",
        fields: [
          "deforestationRequired",
          // "constructArea",
          "leisureArea"
        ]
      }
    ]
  },
  {
    propertyType: 34,
    name: "Fazenda",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue"
        ]
      },
      {
        name: "Características da área",
        key: "featuresPlace",
        fields: [
          "deforestationRequired",
          // "constructArea",
          "leisureArea"
        ]
      }
    ]
  },
  {
    propertyType: 35,
    name: "Haras",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue"
        ]
      },
      {
        name: "Características da área",
        key: "featuresPlace",
        fields: [
          "deforestationRequired",
          // "constructArea",
          "leisureArea"
        ]
      }
    ]
  },
  {
    propertyType: 36,
    name: "Sítio",
    sections: [
      {
        name: "Informações básicas",
        key: "basicInfo",
        fields: [
          "landSizeUseful",
          "iptuArea",
          "iptuValue"
        ]
      },
      {
        name: "Características da área",
        key: "featuresPlace",
        fields: [
          "deforestationRequired",
          // "constructArea",
          "leisureArea",
        ]
      }
    ]
  }
];

